// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__RAAa2","tyre":"style_tyre__4qYs9"};